// extracted by mini-css-extract-plugin
module.exports = {"slider_container":"styles_slider_container__6xMI7","slider":"styles_slider__B5nEd","slide":"styles_slide__yfdCB","slider_controls":"styles_slider_controls__bHB4I"};